export default {
  namespaced: true,

  getters: {
    round: (state, getters, rootState) =>
      rootState.battle.meta && rootState.battle.meta.round,
  },

  actions: {
    increment: ({ dispatch }) => dispatch(`change`),
    decrement: ({ dispatch }) => dispatch(`change`, -1),

    change: (
      { dispatch, getters: { round }, rootGetters: { [`battles/battle`]: id } },
      step = 1
    ) => {
      round = round + step || 1
      dispatch(`battle/update`, { id, round }, { root: true })
    },

    reset: ({ dispatch, rootGetters: { [`battles/battle`]: id } }) =>
      dispatch(`battle/update`, { id, round: 1 }, { root: true }),
  },
}
